import type { Edge, Node } from '@xyflow/react';

export function buildExecIndex(nodes: Node[], edges: Edge[]) {
  const incomingExecByNode: Record<string, string[]> = {};
  const outgoingExecByNode: Record<string, string[]> = {};
  const incomingDataByNode: Record<string, string[]> = {};
  const outgoingDataByNode: Record<string, string[]> = {};
  const edgeById: Record<string, Edge> = {};

  for (const e of edges) {
    edgeById[e.id] = e;
    const ch = (e as any).data?.channel === 'data' ? 'data' : 'exec';
    const inc = ch === 'data' ? incomingDataByNode : incomingExecByNode;
    const out = ch === 'data' ? outgoingDataByNode : outgoingExecByNode;
    (inc[e.target] ||= []).push(e.id);
    (out[e.source] ||= []).push(e.id);
  }

  // normalize missing keys
  for (const n of nodes) {
    incomingExecByNode[n.id] ||= [];
    outgoingExecByNode[n.id] ||= [];
    incomingDataByNode[n.id] ||= [];
    outgoingDataByNode[n.id] ||= [];
  }

  return { incomingExecByNode, outgoingExecByNode, incomingDataByNode, outgoingDataByNode, edgeById };
}

export type ExecIndex = ReturnType<typeof buildExecIndex>;

